import { Matrix23, Vector2 } from '@seddi/math-v2';
import { getInverseTransformMatrix, getTransformMatrix } from '@/core/transformRt2';
/**
 * Fit A within B while keeping aspect ratio.
 * @param a A dimension.
 * @param b B dimension.
 */
export const fit = (a, b) => {
    const aAspectRatio = a.x / a.y;
    const bAspectRatio = b.x / b.y;
    if (aAspectRatio >= bAspectRatio) {
        const scale = b.x / a.x;
        return { x: b.x, y: a.y * scale };
    }
    else {
        const scale = b.y / a.y;
        return { x: a.x * scale, y: b.y };
    }
};
/**
 * Returns true if a is inside b.
 * @param logoSize A size.
 * @param logoTransform A transform (translation + rotation).
 * @param regionSize B size.
 * @param regionTransform B transform.
 */
export const isInside = (() => {
    const EPSILON = 1e-5;
    const logoCorners = [new Vector2(), new Vector2(), new Vector2(), new Vector2()];
    const transformedCorners = [new Vector2(), new Vector2(), new Vector2(), new Vector2()];
    const bMin = new Vector2();
    const bMax = new Vector2();
    const lc = new Vector2();
    const lm = new Matrix23();
    const logoMatrix = new Matrix23();
    return (logoSize, logoTransform, regionSize, regionTransform) => {
        // Get the four corners of the logo in its local space
        const halfWidth = logoSize.x * 0.5;
        const halfHeight = logoSize.y * 0.5;
        logoCorners[0].set(-halfWidth, -halfHeight);
        logoCorners[1].set(halfWidth, -halfHeight);
        logoCorners[2].set(halfWidth, halfHeight);
        logoCorners[3].set(-halfWidth, halfHeight);
        // Apply logo transform to get corners in world space
        getTransformMatrix(logoTransform, logoMatrix);
        for (let i = 0; i < 4; i++) {
            transformedCorners[i].copyFrom(logoCorners[i]);
            logoMatrix.transformRef(transformedCorners[i]);
        }
        // Transform logo corners to region space
        getInverseTransformMatrix(regionTransform, lm);
        for (let i = 0; i < 4; i++) {
            lc.copyFrom(transformedCorners[i]);
            lm.transformRef(lc);
            transformedCorners[i].copyFrom(lc);
        }
        // Check if all transformed corners are inside the region bounds
        bMin.x = regionSize.x * -0.5 - EPSILON;
        bMin.y = regionSize.y * -0.5 - EPSILON;
        bMax.x = regionSize.x * 0.5 + EPSILON;
        bMax.y = regionSize.y * 0.5 + EPSILON;
        for (let i = 0; i < 4; i++) {
            const corner = transformedCorners[i];
            if (corner.x < bMin.x || corner.x > bMax.x || corner.y < bMin.y || corner.y > bMax.y) {
                return false;
            }
        }
        return true;
    };
})();
